<template>
    <!-- contents -->
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size lg_size">
                <a href="javascript:" class="ui_close" @click="$emit('close')"><span class="sr_only"></span></a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ $t('TITLE.CREATE.NEW.QUESTION') }}</i>
                    </dt>
                    <dd>
                        <!-- qna_wrap -->
                        <div class="create_wrap mt-20">
                            <table class="create_table">
                                <colgroup>
                                    <col width="154px" />
                                    <col class="col_width2" />
                                    <col class="col_width3" />
                                    <col class="col_width4" />
                                </colgroup>
                                <caption>
                                    <em class="txt_mandatory">*</em>
                                    {{
                                        $t('FIELD.GLOBAL.MANDATORY')
                                    }}
                                </caption>
                                <tr v-if="'1' === deptLevelCd">
                                    <th>
                                        {{ $t('FIELD.MYKNOWLEDGE.ASC.ACCOUNT.NO') }}<em class="txt_mandatory">*</em>
                                    </th>
                                    <td class="in_td">
                                        <span class="clearable">
                                            <input
                                                type="text"
                                                class="text_input w100p"
                                                v-model="ascAccount"
                                                v-clearable
                                            />
                                        </span>
                                    </td>
                                    <th>({{ $t('FIELD.GLOBAL.ASC.USER') }})</th>
                                </tr>
                                <tr>
                                    <th>
                                        {{ $t('FIELD.GLOBAL.INQUIRY') }}<em class="txt_mandatory">*</em>
                                        <a
                                            href="javascript:"
                                            class="btn_ss_white"
                                            title=""
                                            v-if="'CN' === loginRhq"
                                            @click="searchZHPopup('I')"
                                        >
                                            {{ $t('BUTTON.QNA.ZH') }}
                                        </a>
                                    </th>
                                    <td colspan="3">
                                        <fieldset class="ui_fieldset set_3">
                                            <div>
                                                <select
                                                    class="slt_white w100p"
                                                    v-model="inquiry1Code"
                                                    @change="inquiryList(2)"
                                                >
                                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                                    <option
                                                        v-for="item in inquiry1CodeList"
                                                        :key="pageName + item.CD"
                                                        :value="item.CD"
                                                    >
                                                        {{ item.CD_NAME }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div>
                                                <select class="slt_white w100p" v-model="inquiry2Code">
                                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                                    <option
                                                        v-for="item in inquiry2CodeList"
                                                        :key="pageName + item.CD"
                                                        :value="item.CD"
                                                    >
                                                        {{ item.CD_NAME }}
                                                    </option>
                                                </select>
                                            </div>
                                        </fieldset>
                                    </td>
                                </tr>
                                <tr v-if="'PQ1' !== inquiry1Code">
                                    <th>{{ $t('FIELD.FAST.ADVANCED.MODEL') }}<em class="txt_mandatory">*</em></th>
                                    <td colspan="3">
                                        <fieldset class="ui_fieldset">
                                            <label class="serach-wrap">
                                                <input
                                                    type="text"
                                                    class="text_input cur_pointer"
                                                    :placeholder="$t('BUTTON.GLOBAL.SEARCH')"
                                                    v-model="modelNm"
                                                    @click="searchModelPopup()"
                                                    readonly
                                                />
                                                <a class="in_btn_search">
                                                    <i class="ico_input_serach"></i>
                                                    <span class="sr_only"></span>
                                                </a>
                                            </label>
                                            <label class="checkbox-wrap">
                                                <input
                                                    type="checkbox"
                                                    @click="clearModel()"
                                                    v-model="modelCheck"
                                                    checked
                                                />
                                                <i class="check-icon"></i>
                                                <em>{{ $t('FIELD.FAQ.NOT.RELEVANT') }}</em>
                                            </label>
                                        </fieldset>
                                    </td>
                                </tr>
                                <tr
                                    v-if="!('PQ1' === inquiry1Code || 'PQ4' === inquiry1Code || 'PQ8' === inquiry1Code)"
                                >
                                    <th>
                                        {{ $t('FIELD.GLOBAL.CATEGORY') }}<em class="txt_mandatory">*</em>
                                        <a
                                            href="javascript:"
                                            class="btn_ss_white"
                                            title=""
                                            v-if="'CN' === loginRhq"
                                            @click="searchZHPopup('C')"
                                        >
                                            {{ $t('BUTTON.QNA.ZH') }}
                                        </a>
                                    </th>
                                    <td colspan="3">
                                        <fieldset class="ui_fieldset set_3">
                                            <label class="select-wrap">
                                                <!-- Q50 Product quality > HHP Quality Issue -->
                                                <select
                                                    class="slt_white w100p"
                                                    id="category1Code"
                                                    v-model="category1Code"
                                                    @change="categoryList(2)"
                                                    :disabled="'Q50' === inquiry2Code || !modelCheck"
                                                >
                                                    <option
                                                        v-for="item in category1CodeList"
                                                        :key="pageName + item.code"
                                                        :value="item.code"
                                                    >
                                                        {{ item.codeName }}
                                                    </option>
                                                </select>
                                            </label>
                                            <label class="select-wrap">
                                                <select
                                                    class="slt_white w100p"
                                                    id="category2Code"
                                                    v-model="category2Code"
                                                    @change="categoryList(3)"
                                                    :disabled="!modelCheck"
                                                >
                                                    <option
                                                        v-for="item in category2CodeList"
                                                        :key="pageName + item.code"
                                                        :value="item.code"
                                                    >
                                                        {{ item.codeName }}
                                                    </option>
                                                </select>
                                            </label>
                                            <label class="select-wrap">
                                                <select
                                                    class="slt_white w100p"
                                                    id="category3Code"
                                                    :disabled="!modelCheck"
                                                >
                                                    <option
                                                        v-for="item in category3CodeList"
                                                        :key="pageName + item.code"
                                                        :value="item.code"
                                                    >
                                                        {{ item.codeName }}
                                                    </option>
                                                </select>
                                            </label>
                                        </fieldset>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.GLOBAL.TITLE') }}<em class="txt_mandatory">*</em></th>
                                    <td colspan="3">
                                        <span class="clearable">
                                            <input type="text" class="text_input w100p" v-model="title" v-clearable />
                                        </span>
                                    </td>
                                </tr>
                                <tr
                                    v-if="
                                        'PQ2' === inquiry1Code ||
                                            'PQ3' === inquiry1Code ||
                                            'PQ4' === inquiry1Code ||
                                            'PQ8' === inquiry1Code
                                    "
                                >
                                    <th>{{ $t('FIELD.QNA.REPAIR.TYPE') }}</th>
                                    <td class="in_td">
                                        <select class="slt_white w100p" v-model="repairType">
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in repairTypeList"
                                                :key="pageName + item.CD"
                                                :value="item.CD"
                                            >
                                                {{ item.CDNM }}
                                            </option>
                                        </select>
                                    </td>
                                    <th class="in_th">
                                        <span>{{ $t('FIELD.QNA.SERIAL.NUMBER') }}</span>
                                    </th>
                                    <td>
                                        <span class="clearable">
                                            <input
                                                type="text"
                                                class="text_input w100p"
                                                v-model="serialNumber"
                                                v-clearable
                                            />
                                        </span>
                                    </td>
                                </tr>
                                <tr v-if="'PQ3' === inquiry1Code">
                                    <th>{{ $t('FIELD.MYKNOWLEDGE.PARTS.NUMBER') }}</th>
                                    <td class="in_td">
                                        <span class="clearable">
                                            <input
                                                type="text"
                                                class="text_input w100p"
                                                v-model="partsNumber"
                                                v-clearable
                                            />
                                        </span>
                                    </td>
                                    <th class="in_th">
                                        <span>{{ $t('FIELD.MYKNOWLEDGE.PARTS.NAME') }}</span>
                                    </th>
                                    <td>
                                        <span class="clearable">
                                            <input
                                                type="text"
                                                class="text_input w100p"
                                                v-model="partsName"
                                                v-clearable
                                            />
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <th
                                        v-if="
                                            'PQ2' === inquiry1Code ||
                                                'PQ4' === inquiry1Code ||
                                                'PQ8' === inquiry1Code ||
                                                'PQ6' === inquiry1Code ||
                                                'PQ7' === inquiry1Code ||
                                                'PQ9' === inquiry1Code
                                        "
                                    >
                                        {{ $t('FIELD.QNA.SVC.ORDER') }}
                                    </th>
                                    <td
                                        class="in_td"
                                        v-if="
                                            'PQ2' === inquiry1Code ||
                                                'PQ4' === inquiry1Code ||
                                                'PQ8' === inquiry1Code ||
                                                'PQ6' === inquiry1Code ||
                                                'PQ7' === inquiry1Code ||
                                                'PQ9' === inquiry1Code
                                        "
                                    >
                                        <span class="clearable">
                                            <input
                                                type="text"
                                                class="text_input w100p"
                                                v-model="svcOrder"
                                                v-clearable
                                            />
                                        </span>
                                    </td>
                                    <th
                                        :class="'PQ3' === inquiry1Code ? '' : 'in_th'"
                                        v-if="'PQ2' === inquiry1Code || 'PQ3' === inquiry1Code || 'D' === category1Code"
                                    >
                                        <span>{{ $t('FIELD.MYKNOWLEDGE.IMEI') }}</span>
                                    </th>
                                    <td
                                        :class="'PQ3' === inquiry1Code ? 'in_td' : ''"
                                        v-if="'PQ2' === inquiry1Code || 'PQ3' === inquiry1Code || 'D' === category1Code"
                                    >
                                        <span class="clearable">
                                            <input type="text" class="text_input w100p" v-model="IMEI" v-clearable />
                                        </span>
                                    </td>
                                    <!-- QPA005, Q7 (Srevice Parts > Parts claim) -->
                                    <th class="in_th" v-if="'QPA005' === inquiry2Code || 'Q7' === inquiry2Code">
                                        <span>{{ $t('FIELD.MYKNOWLEDGE.DEPOT.LOCATION') }}</span>
                                    </th>
                                    <!-- depotLocCdList -->
                                    <td v-if="'QPA005' === inquiry2Code || 'Q7' === inquiry2Code">
                                        <select class="slt_white w100p" v-model="depotLocCd">
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in depotLocCdList"
                                                :key="pageName + item.CD"
                                                :value="item.CD"
                                            >
                                                {{ item.CDNM }}
                                            </option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.GLOBAL.ANSWER.REQUIRED.DATE') }}</th>
                                    <td class="in_td">
                                        <fieldset class="ui_fieldset">
                                            <label class="date-wrap">
                                                <input
                                                    id="toDate"
                                                    type="text"
                                                    class="date_input w100p"
                                                    placeholder="MM.DD.YYYY"
                                                    readonly maxlength="20"
                                                />
                                                <a href="javascript:" class="in_btn" id="icoToDate">
                                                    <i class="ico_date"></i>
                                                    <span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span>
                                                </a>
                                                <div class="to_datepicker" id="to-picker-container" />
                                            </label>
                                        </fieldset>
                                    </td>
                                    <th class="in_th">
                                        <span>{{ $t('FIELD.GLOBAL.URGENT') }}</span>
                                    </th>
                                    <td>
                                        <label class="checkbox-wrap">
                                            <input type="checkbox" v-model="urgentYn" true-value="Y" false-value="N" />
                                            <i class="check-icon"></i>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.GLOBAL.QNA.DESC') }}<em class="txt_mandatory">*</em></th>
                                    <td colspan="3">
                                        <cross-editor
                                            :editorId="pageName + 'Cross'"
                                            :editorData="questionDesc"
                                        ></cross-editor>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.GLOBAL.ATTACHMENT') }}</th>
                                    <td colspan="3" class="no_padding">
                                        <innorix-upload
                                            :uploadId="pageName"
                                            :id="pageName"
                                            :name="pageName"
                                            :serviceType="serviceType"
                                            :onlyUpload="onlyUpload"
                                            :attachList="attach"
                                            @files="setFiles"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </dd>
                    <dd class="scroll_btm">
                        <div class="btn_wrap_full topLine">
                            <div class="btn_right">
                                <a href="javascript:" class="btn_blue" title="" @click="save(0)">
                                    {{ $t('BUTTON.GLOBAL.REGISTER') }}
                                </a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
    <!-- contents -->
</template>
<script>
import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';
import qs from 'query-string';
import $ from 'jquery';
import store from '@/vuex/store';
import { SDLUtil, StringUtil, DateUtil, MenuUtil } from '@/utils';
import { mapActions, mapGetters } from 'vuex';
import api from '@/service';
import searchModelPopup from '~vb/faq/popup/searchModelPopup';
import searchZHPopup from '~vb/faq/popup/searchZHPopup';
import DatePicker from '~c/DatePicker';
import CrossEditor from '~c/CrossEditor';
import InnorixUpload from '~c/InnorixUpload';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

require('moment-jdateformatparser');

export default {
    name: 'createNewQuestion',
    components: {
        'cross-editor': CrossEditor,
        'innorix-upload': InnorixUpload,
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    data() {
        return {
            pageName: 'createNewQuestion',
            pageTitle: '',
            inquiry1Code: '',
            inquiry2Code: '',
            inquiry1CodeList: [],
            inquiry2CodeList: [],
            category1Code: '',
            category2Code: '',
            category3Code: '',
            category1CodeList: [],
            category2CodeList: [],
            category3CodeList: [],
            modelCd: '',
            modelNm: '',
            modelCheck: true,
            title: '',
            questionDesc: '',
            solutionDesc: '',
            serviceType: 'common',
            attach: [],
            onlyUpload: false,
            userNo: '',
            questionId: '',
            preQuestionId: '',
            ascAccount: '',
            repairType: '',
            repairTypeList: [],
            serialNumber: '',
            svcOrder: '',
            IMEI: '',
            requiredDt: '',
            urgentYn: 'N',
            depotLocCd: '',
            depotLocCdList: [],
            partsNumber: '',
            partsName: '',
            attachFileSeq: [],
            delAttachFiles: [],
            isRemove: false,
        };
    },
    mounted() {
        // this.initializeSearch(true);
        let toDate = new Date();
        toDate.setDate(toDate.getDate() + 6);

        this.requiredDt = DatePicker.create('to-picker-container', 'toDate', 'icoToDate', 'en', {}, toDate);
        this.searchCode('DEPOT_LOC_CD');
        this.searchCode('REPAIR_TYPE');
        this.inquiryList(1);
        this.categoryList(1);

        if (!SDLUtil.isNull(this.getQuestionId) || !SDLUtil.isNull(this.getPreQuestionId)) {
            this.searchDetail(SDLUtil.nvl(this.getQuestionId), SDLUtil.nvl(this.getPreQuestionId));
        } else {
            this.initializeSearch(true);
        }
    },
    computed: {
        ...mapGetters({
            loginRhq: 'getLoginRhq',
            corpCd: 'getCorpCd',
            deptLevelCd: 'getDeptLevelCd',
            supportSnbParams: 'getSupportSnbParams',
            menus: 'getMenus',
        }),
        getQuestionId() {
            let questionId = (this.$route.query.questionId || '').trim();
            return questionId;
        },
        getPreQuestionId() {
            let preQuestionId = (this.$route.query.preQuestionId || '').trim();
            return preQuestionId;
        },
    },
    watch: {
        supportSnbParams() {
            this.initializeSearch();
        },
        inquiry2Code() {
            if (this.inquiry2Code === 'Q50') {
                this.category1Code = 'D';
                this.categoryList(2);
            }
        },
    },
    methods: {
        //function start
        //initialize start
        async initializeSearch() {
            if (SDLUtil.isNull(this.supportSnbParams.faqType)) {
                this.inquiry1Code = this.supportSnbParams.faqInquiry1Code;
                this.inquiry2Code = this.supportSnbParams.faqInquiry2Code;
                this.category1Code = this.supportSnbParams.faqCategory1Code;
                this.category2Code = this.supportSnbParams.faqCategory2Code;
                this.inquiryList(2);
                this.categoryList(2);
            } else if ('I' === this.supportSnbParams.faqType) {
                this.inquiry1Code = this.supportSnbParams.faqInquiry1Code;
                this.inquiry2Code = this.supportSnbParams.faqInquiry2Code;
                this.inquiryList(2);
            } else if ('C' === this.supportSnbParams.faqType) {
                this.category1Code = this.supportSnbParams.faqCategory1Code;
                this.category2Code = this.supportSnbParams.faqCategory2Code;
                this.categoryList(2);
            }
        },
        //initialize end
        //search option start
        //search option end

        //search area start
        async inquiryList(v) {
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/inquiryItem/inquiryItemList.skp`,
                    qs.stringify({
                        type: 'inquiryType' + v,
                        useyn: 'Y',
                        deptLevelCd: this.deptLevelCd,
                        deptNo: this.corpCd,
                        value: this.inquiry1Code,
                    }),
                )
                .then(resp => {
                    if (v === 1) {
                        this.inquiry1CodeList = resp.data.result.rowData;
                        let code = this.inquiry1Code;
                        const idx = this.inquiry1CodeList.findIndex(function(item) {
                            return item.CD === code;
                        });
                        if (0 > idx) {
                            if (!SDLUtil.isNull(this.inquiry1CodeList[0]) && SDLUtil.isNull(this.inquiry1Code)) {
                                this.inquiry1Code = this.inquiry1CodeList[0].CD;
                            } else {
                                this.inquiry1Code = '';
                            }
                        }
                        this.inquiryList(2);
                    } else if (v === 2) {
                        this.inquiry2CodeList = resp.data.result.rowData;
                        let code = this.inquiry2Code;
                        const idx = this.inquiry2CodeList.findIndex(function(item) {
                            return item.CD === code;
                        });
                        if (0 > idx) {
                            if (!SDLUtil.isNull(this.inquiry2CodeList[0]) && SDLUtil.isNull(this.inquiry2Code)) {
                                this.inquiry2Code = this.inquiry2CodeList[0].CD;
                            } else {
                                this.inquiry2Code = '';
                            }
                        }
                    }
                });
        },
        async categoryList(v) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'ADM_CATEGORY_A';
                parentCode = '0';
                this.category1CodeList = [];
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category1CodeList = resp;
                    if (!SDLUtil.isNull(resp[0]) && SDLUtil.isNull(this.category1Code)) {
                        this.category1Code = resp[0].code.trim();
                    }
                    this.categoryList(2);
                });
            } else if (v === 2) {
                codeCategoryId = 'ADM_CATEGORY_B';
                parentCode = this.category1Code;
                this.category2CodeList = [];
                this.category3CodeList = [];
                let code = this.category2Code;
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category2CodeList = resp;
                    const idx = resp.findIndex(function(item) {
                        return item.code === code;
                    });
                    if (0 > idx) {
                        if (!SDLUtil.isNull(resp[0])) {
                            this.category2Code = resp[0].code.trim();
                        } else {
                            this.category2Code = '';
                        }
                    }
                    this.categoryList(3);
                });
            } else if (v === 3) {
                codeCategoryId = 'ADM_CATEGORY_C';
                parentCode = this.category2Code;
                this.category3CodeList = [];
                let code = this.category3Code;
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category3CodeList = resp;
                    const idx = resp.findIndex(function(item) {
                        return item.code === code;
                    });
                    if (0 > idx) {
                        if (!SDLUtil.isNull(resp[0])) {
                            this.category3Code = resp[0].code.trim();
                        } else {
                            this.category3Code = '';
                        }
                    }
                });
            }
        },
        searchModelPopup() {
            let searchModel = this.modelNm;
            SDLUtil.show(
                searchModelPopup,
                {
                    searchModel,
                    rtnFunc: (arg1, arg2, arg3, arg4, arg5) => {
                        this.modelCd = arg1;
                        this.modelNm = arg2;
                        this.modelCheck = false;
                        this.category1Code = arg3;
                        this.category2Code = arg4;
                        this.category2Code = arg5;
                        this.categoryList(2);
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        searchZHPopup(v) {
            let dispType = v;
            SDLUtil.show(
                searchZHPopup,
                { dispType },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        clearModel() {
            if (!this.modelCheck) {
                this.modelCd = '';
                this.modelNm = '';
            }
        },
        async searchDetail(questionId, preQuestionId) {
            let url = `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/detailPopupView.skp`;
            let question_Id = questionId;
            if (!SDLUtil.isNull(preQuestionId)) {
                url = `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/detailPopupView.skp`;
                question_Id = preQuestionId;
            }
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(url, qs.stringify({ questionId: question_Id }))
                .then(resp => {
                    let detail = resp.data.result.rowData[0];

                    this.questionId = questionId;
                    this.preQuestionId = preQuestionId;
                    this.ascAccount = detail.ASC_ACCOUNT;
                    this.repairType = detail.REPAIR_TYPE;
                    this.serialNumber = detail.SERIAL_NUMBER;
                    this.svcOrder = detail.SVC_ORDER;
                    this.IMEI = detail.MCK_IMEI;
                    this.urgentYn = detail.URGENT_YN;
                    this.modelCd = detail.MODEL_CD;
                    this.modelNm = detail.MODEL_NM;
                    this.title = detail.TITLE;
                    this.questionDesc = this.stripHtml(detail.QUESTION_DESC);
                    this.userNo = detail.REG_USER_NO;

                    this.inquiry1Code = SDLUtil.nvl(detail.INQUIRY_TYPE1);
                    this.inquiry2Code = SDLUtil.nvl(detail.INQUIRY_TYPE2);
                    this.category1Code = SDLUtil.nvl(detail.PRD_CATEGORY_CD1);
                    this.category2Code = SDLUtil.nvl(detail.PRD_CATEGORY_CD2);
                    this.category3Code = SDLUtil.nvl(detail.PRD_CATEGORY_CD3);
                    this.inquiryList(2);
                    this.categoryList(2);

                    if (!SDLUtil.isNull(this.modelCd)) {
                        this.modelCheck = false;
                    }

                    let mDate = localStorage.getItem('mDateFormat');
                    this.requiredDt = DatePicker.create(
                        'to-picker-container',
                        'toDate',
                        'icoToDate',
                        'en',
                        {},
                        moment(detail.REG_DT, mDate).toDate(),
                    );

                    this.attach = resp.data.attach.rowData;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        async searchCode(v) {
            SDLUtil.showLoadingBar(true);
            return await axios
                .get(`${SDLUtil.API_URL}/basis/common/getCodeList.skp`, { params: { codeCategoryId: v } })
                .then(resp => {
                    if ('DEPOT_LOC_CD' === v) {
                        this.depotLocCdList = resp.data.result.rowData;
                    } else if ('REPAIR_TYPE' === v) {
                        this.repairTypeList = resp.data.result.rowData;
                    }

                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        //search area end

        //page move start
        menuCommit(menu, subMenu, conUrl) {
            for (const menus of this.menus) {
                for (const menu of menus.subMenu) {
                    let connUrl = menu.connUrl.replace('.skp', '');
                    if (conUrl === connUrl) {
                        store.commit('PARAMS', { menuId: menu.menuId, creationYn: menu.creationYn });
                        return connUrl;
                    }
                }
            }

            return MenuUtil.getSupportMain();
        },
        //page move end

        //save start
        saveDraft(v) {
            let LENGTH = SDLUtil.getMsgProp('MESSAGE.DATA.MAX.LENGTH');
            if (!SDLUtil.lengthCheck(this.title, 78)) {
                SDLUtil.alert('[' + SDLUtil.getMsgProp('FIELD.GLOBAL.TITLE') + ']' + LENGTH.replace('{0}', '78'));
                return false;
            }
            let requiredDt = this.requiredDt.getDate()
                ? moment(this.requiredDt.getDate()).formatWithJDF(
                      moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy'),
                  )
                : '';
            SDLUtil.showLoadingBar(true);
            this.questionDesc = window.createNewQuestionCross.GetBodyValue('XHTML');
            return axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionSaveDraft.skp`,
                    qs.stringify({
                        questionId: this.questionId,
                        preQuestionId: this.preQuestionId,
                        forDeptLevelCd: this.deptLevelCd,
                        forDeptNo: this.corpCd,
                        inquiryType1: this.inquiry1Code,
                        inquiryType2: this.inquiry2Code,
                        prdCategoryCd1: this.category1Code,
                        prdCategoryCd2: this.category2Code,
                        prdCategoryCd3: this.category3Code,
                        ascAccount: this.ascAccount,
                        repairType: this.repairType,
                        serialNumber: this.serialNumber,
                        svcOrder: this.svcOrder,
                        IMEI: this.IMEI,
                        requiredDt: requiredDt,
                        urgentYn: this.urgentYn,
                        modelCd: this.modelCd,
                        title: this.title,
                        questionDesc: this.questionDesc,
                        partsNumber: this.partsNumber,
                        partsName: this.partsName,
                        depotLocCd: this.depotLocCd,
                        attachFileSeq: this.attachFileSeq.map(item => item.attachFileSeq),
                        delAttachFiles: this.delAttachFiles.map(item => item.attachFileSeq),
                        isRemove: this.isRemove,
                    }),
                )
                .then(resp => {
                    this.questionId = resp.data.questionId;
                    SDLUtil.alert(resp.data.msg);
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        save(v) {
            let requiredDt = this.requiredDt.getDate()
                ? moment(this.requiredDt.getDate()).formatWithJDF(
                      moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy'),
                  )
                : '';

            let prdCategoryCd1 = this.category1Code;
            let prdCategoryCd2 = this.category2Code;
            let prdCategoryCd3 = this.category3Code;

            let MENDATORY = SDLUtil.getMsgProp('MESSAGE.FIELD.CHECK.MENDATORY');
            let LENGTH = SDLUtil.getMsgProp('MESSAGE.DATA.MAX.LENGTH');

            if (0 === SDLUtil.textLength(this.title)) {
                SDLUtil.alert(MENDATORY.replace('{0}', SDLUtil.getMsgProp('FIELD.GLOBAL.TITLE')));
                return false;
            } else if (!SDLUtil.lengthCheck(this.title, 78)) {
                SDLUtil.alert('[' + SDLUtil.getMsgProp('FIELD.GLOBAL.TITLE') + ']' + LENGTH.replace('{0}', '78'));
                return false;
            } else if (0 === SDLUtil.textLength(window.createNewQuestionCross.GetTextValue())) {
                SDLUtil.alert(MENDATORY.replace('{0}', SDLUtil.getMsgProp('FIELD.GLOBAL.QNA.DESC')));
                return false;
            } else if (SDLUtil.isNull(this.inquiry1Code) || SDLUtil.isNull(this.inquiry2Code)) {
                SDLUtil.alert(MENDATORY.replace('{0}', SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY')));
                return false;
            } else if ('PQ1' === this.inquiry1Code || 'PQ4' === this.inquiry1Code || 'PQ8' === this.inquiry1Code) {
                prdCategoryCd1 = '';
                prdCategoryCd2 = '';
                prdCategoryCd3 = '';
            } else if (
                SDLUtil.isNull(prdCategoryCd1) ||
                SDLUtil.isNull(prdCategoryCd2) ||
                SDLUtil.isNull(prdCategoryCd3)
            ) {
                SDLUtil.alert(MENDATORY.replace('{0}', SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY')));
                return false;
            }

            this.questionDesc = window.createNewQuestionCross.GetBodyValue('XHTML');
            let url = `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionSave.skp`;
            if (!SDLUtil.isNull(this.questionId)) {
                url = `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionUpdate.skp`;
            }
            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.DATA.SAVE.CONFIRM'),
                // title: SDLUtil.getMsgProp('BUTTON.GLOBAL.REGISTER'),
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            url,
                            qs.stringify({
                                questionId: this.questionId,
                                preQuestionId: this.preQuestionId,
                                forDeptLevelCd: this.deptLevelCd,
                                forDeptNo: this.corpCd,
                                inquiryType1: this.inquiry1Code,
                                inquiryType2: this.inquiry2Code,
                                prdCategoryCd1: prdCategoryCd1,
                                prdCategoryCd2: prdCategoryCd2,
                                prdCategoryCd3: prdCategoryCd3,
                                ascAccount: this.ascAccount,
                                repairType: this.repairType,
                                serialNumber: this.serialNumber,
                                svcOrder: this.svcOrder,
                                IMEI: this.IMEI,
                                requiredDt: requiredDt,
                                urgentYn: this.urgentYn,
                                modelCd: this.modelCd,
                                title: this.title,
                                questionDesc: this.questionDesc,
                                partsNumber: this.partsNumber,
                                partsName: this.partsName,
                                depotLocCd: this.depotLocCd,
                                attachFileSeq: this.attachFileSeq.map(item => item.attachFileSeq),
                                delAttachFiles: this.delAttachFiles.map(item => item.attachFileSeq),
                                isRemove: this.isRemove,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            SDLUtil.alert(resp.data.msg);
                            this.questionId = resp.data.questionId;
                            if (SDLUtil.isNull(this.questionId)) return false;
                            return this.$emit('close');
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        //save end

        //etc start
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.corpCd);
            return codeResp;
        },
        stripHtml(html) {
            var tmp = document.createElement('html');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
        },
        setFiles(val) {
            this.attachFileSeq = val.fileList || [];
            this.delAttachFiles = val.delFileList || [];
            this.isRemove = val.isRemove || false;
        },
        //etc end
        //function end
    },
};
</script>

<style scoped>
.zindex9999 {
    z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/faq/popup/createNewQuestionPopup.vue